import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Topbar = ({ collapsed, setCollapsed }) => {
  useEffect(() => {
    const menuIcon = document.querySelector(".wrapper-menu");
    const mobileMenu = document.querySelector(".mobile-menu-wrapper");
    menuIcon.onclick = () => {
      mobileMenu.classList.toggle("mobile-menu-wrapper-collapsed");
    };
  }, [collapsed]);
  return (
    <div className="top-menu h-16 bg-white border-b-2">
      <div className="navbar ">
        <div className="navbar-start">
          <label htmlFor="sidebar-menu" className="block mx-3">
            <input
              type="checkbox"
              id="sidebar-menu"
              className="checkbox hidden"
              onChange={() => {
                setCollapsed(!collapsed);
              }}
            />
            <i className="fa-solid fa-bars wrapper-menu text-xl mx-1"></i>
          </label>
          <div className=" w-2/3 ml-4 flex">
            <h1 className="font-bold font-serif text-3xl"><span className="text-[#E74C3C]">K</span> <span className="text-[#27ae60]">S</span> <span className="text-[#303640]">S</span></h1>
          </div>
        </div>

        <div className="navbar-end">
          <div className="flex items-center">
            <div className="dropdown dropdown-end">
              <label tabIndex="0" className="btn btn-ghost btn-circle">
                <button className="btn btn-ghost btn-circle">
                  <div className="indicator">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                      />
                    </svg>
                    <span className="badge badge-xs badge-primary indicator-item"></span>
                  </div>
                </button>
              </label>
              <div
                tabIndex="0"
                className="mt-3 card card-compact dropdown-content w-52 bg-base-100 shadow"
              >
                <div className="card-body">
                  <div className="flex justify-between items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                      />
                    </svg>
                    <h1>Simple notification</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="dropdown dropdown-end">
              <label tabIndex="0" className="btn btn-ghost btn-circle avatar">
                <div className="w-10 rounded-full">
                  <img
                    src="https://api.lorem.space/image/face?hash=33791"
                    alt="img"
                  />
                </div>
              </label>
              <ul
                tabIndex="0"
                className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
              >
                <li>
                  <Link to="/profile" className="justify-between">
                    Profile
                    <span className="badge">New</span>
                  </Link>
                </li>
                <li>
                  <Link to="/settings" className="justify-between">
                    Settings
                    {/* <span className="badge">New</span> */}
                  </Link>
                </li>
                <li>
                  <a>Logout</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
